import React, { useMemo, useState } from "react";
import { format } from "date-fns";
import Table from "../../../components/ui/table/Table";

const CorporateActionConfig = ({ tableData, loading }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "date",
        header: "DATE",
        size: 130,
        Cell: ({ row }) => format(new Date(row.original.date), "dd MMM yyyy"),
        sortingFn: "datetime",
      },
      {
        accessorKey: "day",
        header: "WEEKDAY",
        size: 120,
      },
      {
        accessorKey: "file_name",
        header: "FILE NAME",
        size: 150,
      },

      {
        accessorKey: "ip_cnt",
        header: "Records Received",
        size: 180,
        filterFn: "equals",
        mantineTableHeadCellProps: { align: "right" },
        mantineTableBodyCellProps: { align: "right" },
      },

      {
        accessorKey: "op_cnt",
        header: "Records Inserted",
        size: 180,
        filterFn: "equals",
        mantineTableHeadCellProps: { align: "right" },
        mantineTableBodyCellProps: { align: "right" },
      },

      {
        accessorKey: "status",
        header: "STATUS",
        size: 120,
      },
    ],
    [],
  );

  return (
    <Table
      pageName={"MutualFund"}
      userId={JSON.parse(sessionStorage.getItem("user"))?.userId}
      tableData={tableData}
      columns={columns}
      loading={loading}
    />
  );
};

export default CorporateActionConfig;
